<template>
  <Render></Render>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
const { locale } = useI18n({ useScope: 'global' })
locale.value = window.config.languageId + "";
import Render from './components/Render.vue';
import '@/assets/scss/style.scss'
</script>
